import { render, staticRenderFns } from "./WtStatRow.vue?vue&type=template&id=3a28ffd6&scoped=true&lang=pug&"
import script from "./WtStatRow.vue?vue&type=script&lang=js&"
export * from "./WtStatRow.vue?vue&type=script&lang=js&"
import style0 from "./WtStatRow.vue?vue&type=style&index=0&id=3a28ffd6&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a28ffd6",
  null
  
)

export default component.exports